import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatDialog } from '@angular/material/dialog'
import { FormsModule } from '@angular/forms'
import { SupplierPortalQuoteService } from '../../../core/services/supplier-portal/supplier-portal-quote.service'
import { TableListSupplierPortalQuoteComponent } from '../../../shared/components/table-list-supplier-portal-quote/table-list-supplier-portal-quote.component'
import { ModalSupplierPortalQuotePriceComponent } from '../modal-supplier-portal-quote-price/modal-supplier-portal-quote-price.component'
import { FornecedorCotacaoPortalVm } from '../../../core/models/supplier-portal.model'
import { OPCOES_FILTRO_STATUS, STATUS_ITEM } from '../supplier-portal-quote-status.util'

// Aba "Solicitações de Cotação" do Portal do Fornecedor. Cada linha é um trecho que a TG mandou
// este fornecedor cotar; ele informa os valores e o item trava. Criar tarifário, criar cotação e
// encerrar solicitação continuam sendo só do operador — não existem aqui.
@Component({
  selector: 'supplier-portal-quote-list',
  standalone: true,
  imports: [
    MatCard,
    MatProgressBar,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    TableListSupplierPortalQuoteComponent,
  ],
  templateUrl: './supplier-portal-quote-list.component.html',
  styleUrl: './supplier-portal-quote-list.component.scss',
})
export class SupplierPortalQuoteListComponent implements OnInit {
  constructor(
    private supplierPortalQuoteService: SupplierPortalQuoteService,
    private dialog: MatDialog,
  ) {}

  // Avisa o container para recontar o badge da aba — um trecho respondido deixa de ser pendente.
  @Output() respostaEnviada = new EventEmitter<void>()

  page = 1
  rows = 10
  numberRows = 0
  itemsList: FornecedorCotacaoPortalVm[] = []
  loading = false

  // Abre no que exige ação do fornecedor; "Todas" está no droplist.
  statusId: number = STATUS_ITEM.ENVIADO_FORNECEDOR
  opcoesStatus = OPCOES_FILTRO_STATUS

  columns: any[] = [
    { keyColumn: 'tg_evento', key: '', description: 'Proposta' },
    { keyColumn: 'trecho', key: '', description: 'Trecho' },
    { keyColumn: 'periodo', key: '', description: 'Período' },
    { keyColumn: 'servico', key: '', description: 'Serviço' },
    { keyColumn: 'veiculo', key: '', description: 'Veículo/Motorista' },
    { keyColumn: 'valores', key: '', description: 'Valores' },
    { keyColumn: 'status', key: '', description: 'Status' },
    { keyColumn: 'action', key: '', description: 'Ações' },
  ]

  ngOnInit() {
    this.getListItems()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.getListItems()
  }

  onStatusChange() {
    this.page = 1
    this.getListItems()
  }

  treatResponse(response: any) {
    // lista vazia volta como 206 com data null
    this.itemsList = response.data ?? []
    this.numberRows = response.totalItens ?? 0
  }

  uploadList() {
    this.getListItems()
  }

  getListItems() {
    this.loading = true
    this.supplierPortalQuoteService
      .listPagedCotacoes(this.page, this.rows, this.statusId)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: () => {
          this.itemsList = []
          this.numberRows = 0
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  openItem(item: FornecedorCotacaoPortalVm) {
    const dialogRef = this.dialog.open(ModalSupplierPortalQuotePriceComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1000px',
      maxWidth: '1000px',
      maxHeight: '90vh',
      data: item,
    })
    dialogRef.componentInstance.response.subscribe((response: boolean) => {
      if (response) {
        this.uploadList()
        this.respostaEnviada.emit()
      }
    })
  }
}
